function FraudStatusDirective() {
  return {
    restrict: 'E',
    scope: {
      status: '=',
      tooltip: '@',
      tooltipPlacement: '=',
      showNoStatus: '='
    },
    template: `<span class="fraud-status badge badge-fraud-{{ status.toLowerCase() }}" ng-if="status || showNoStatus" uib-tooltip="{{ getTooltip() }}" tooltip-placement="{{ tooltipPlacement }}">
      <span ng-show="status"><i class="ion-flag"></i> <span class="capitalize">{{ getRiskForFraudStatus(status) }}</span> Risk</span>
      <span ng-hide="status"><i class="ion-flag"></i> Risk Unknown</span>
    </span>`,
    link(scope, element) {
      element.popover({
        html: true,
        trigger: 'hover',
        container: '#example',
        placement: 'top'
      });

      scope.getTooltip = function () {
        if (!scope.status) return '';
        else if (scope.tooltip) {
          if (scope.status === 'HIGH') return 'Customer has been flagged as having a high likelihood of fraud';
          else if (scope.status === 'MEDIUM') return 'Customer has been flagged as having a medium likelihood of fraud';
          else if (scope.status === 'LOW') return 'Customer has been flagged as having a low likelihood of fraud';
          return null;
        }
        return null;
      };

      scope.getRiskForFraudStatus = function (fraudStatus) {
        let risk;

        switch (fraudStatus) {
        case 'LOW':
          risk = 'Low';
          break;
        case 'MEDIUM':
          risk = 'Medium';
          break;
        case 'HIGH':
          risk = 'High';
          break;
        default:
          risk = null;
          break;
        }

        return risk;
      };
    }
  };
}

FraudStatusDirective.$inject = [];

export default FraudStatusDirective;



// WEBPACK FOOTER //
// ./src/directives/fraudStatus.js